export function getCookie(key: string) {
    const encodedName = encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&");
    const regex = new RegExp(
        "(?:(?:^|.*;)\\s*" + encodedName + "\\s*\\=\\s*([^;]*).*$)|^.*$"
    );

    return decodeURIComponent(document.cookie.replace(regex, "$1")) || null;
}
